/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import {
  GroupAssociation,
  GroupAssociationFromJSON,
  GroupAssociationFromJSONTyped,
  GroupAssociationToJSON,
} from "./GroupAssociation";

/**
 *
 * @export
 * @interface GroupAssociationFetchResponse
 */
export interface GroupAssociationFetchResponse {
  /**
   *
   * @type {GroupAssociation}
   * @memberof GroupAssociationFetchResponse
   */
  data: GroupAssociation;
}

export function GroupAssociationFetchResponseFromJSON(
  json: any
): GroupAssociationFetchResponse {
  return GroupAssociationFetchResponseFromJSONTyped(json, false);
}

export function GroupAssociationFetchResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GroupAssociationFetchResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: GroupAssociationFromJSON(json["data"]),
  };
}

export function GroupAssociationFetchResponseToJSON(
  value?: GroupAssociationFetchResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: GroupAssociationToJSON(value.data),
  };
}
